import React from "react";
import "./Livraison.scss";
import { withRouter } from "react-router-dom";
import { mtLrftUrl } from "../config";
import { auth } from "../Authentication/Authentication";
import * as Storage from "../Authentication/Storage";

export class Livraison extends React.Component {
	state = {
		showEglise: true,
		eglises: []
	};

	componentDidMount() {
		this.loadEglises();
		!this.props.app.state.elements.egliseId &&
			this.props.app.setState({
				elements: {
					...this.props.app.state.elements,
					["livraisonDomicile"]: false,
					["egliseId"]: this.props.app.state.elements.egliseId
				}
			});
	}

	async loadEglises() {
		try {
			const accessToken = await auth.getAccessToken(); // on attend le token

			if (!accessToken) {
				console.warn("Pas de token dispo, on ne fetch pas.");
				return;
			}

			console.log("Access Token: ", accessToken);
			const user = Storage.getUserParsed();
			if (!user) return;
			console.log("OK");
			const response = await fetch(`${mtLrftUrl}/egliseDeliveries`, {
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: "Bearer " + accessToken
				}
			});

			if (response.status !== 200) {
				console.log("Error: " + response.status);
				return;
			}

			const data = await response.json();
			const eglises = data.data;

			if (eglises) {
				this.setState({
					eglises: eglises
				});
			}
		} catch (error) {
			console.error("Erreur lors du chargement des églises :", error);
		}
	}

	async handleSuivant() {
		try {
			const dataElements = this.props.app.state.elements;
			var message = {};
			console.table(dataElements);
			message = JSON.stringify(dataElements);
			console.log(message);

			const accessToken = await auth.getAccessToken(); // on attend le token

			if (!accessToken) {
				console.warn("Pas de token dispo, on ne fetch pas.");
				return;
			}

			console.log("Access Token: ", accessToken);
			const user = Storage.getUserParsed();
			if (!user) return;

			const response = await fetch(`${mtLrftUrl}/public/abonnements`, {
				method: "POST",
				body: message,
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: "Bearer " + accessToken
				}
			});

			if (response.status !== 200) {
				console.log("Error: " + response.status);
				this.props.app.setState(
					{
						messageModal:
							"Probleme avec le serveur, veuillez réessayer plus tard ou nous contacter via la page contact.",
						showModal: true
					},
					() => sessionStorage.setItem("tabFormulaire", 1)
				);
				return;
			}

			const data = await response.json();
			const abonne = data.data;

			if (abonne) {
				console.log(abonne);
				sessionStorage.setItem("idTransaction", abonne.id);
				sessionStorage.setItem("tabFormulaire", 4);
				sessionStorage.setItem("montantAPayer", abonne.montant);
				sessionStorage.setItem("nombreRevues", abonne.nombreRevues);
				sessionStorage.setItem("livraisonDomicile", abonne.livraisonDomicile);
				sessionStorage.setItem("montantAbonnement", abonne.montantAbonnement);
				this.props.app.setState({ tabFormulaire: 4 }, () => {
					// console.table(this.props.app.state.elements);
				});
			}
		} catch (err) {
			console.error(err);
			this.props.app.setState(
				{
					messageModal:
						"Le serveur est indisponible, veuillez réessayer plus tard",
					showModal: true
				},
				() => sessionStorage.setItem("tabFormulaire", 1)
			);
		}
	}

	handleChange = event => {
		console.log(event);
		let target = event.target;
		let value = target.value;
		let id = target.id;
		console.log(event.target.checked);
		console.log(value);
		console.log(id);
		if (
			id === "choixLivraison" &&
			value === "Livraison dans une église de la Mission (gratuit)"
		) {
			this.setState({ showEglise: true });
			this.props.app.setState(
				{
					elements: {
						...this.props.app.state.elements,
						["livraisonDomicile"]: false,
						["egliseId"]: this.state.eglises[0].id
					}
				},
				() => console.table(this.props.app.state.elements)
			);
		}
		if (
			id === "choixLivraison" &&
			value === "Livraison à domicile (4€/revue)"
		) {
			this.setState({ showEglise: false });
			this.props.app.setState(
				{
					elements: {
						...this.props.app.state.elements,
						["livraisonDomicile"]: true,
						["egliseId"]: null
					}
				}
				// () => console.table(this.props.app.state.elements)
			);
		}
		if (id === "eglise") {
			this.props.app.setState(
				{
					elements: {
						...this.props.app.state.elements,
						["livraisonDomicile"]: false,
						["egliseId"]: parseInt(value, 10)
					}
				}
				// () => console.table(this.props.app.state.elements)
			);
		}
	};

	render() {
		return (
			<>
				<div className="livraison">
					<p className="text-center">
						Pour des raisons de coûts, nous préferons quand cela est possible,
						vous livrer dans l'une des églises de la Mission Timothée.
					</p>
					<form>
						<div className="form-row">
							<div className="form-group col-md-6">
								<label htmlFor="choixLivraison" className="col-form-label">
									Type de livraison
								</label>
								<select
									style={{ backgroundColor: "#f6f6f6" }}
									onChange={this.handleChange}
									className="form-control"
									name="choixLivraison"
									id="choixLivraison"
								>
									<option>
										Livraison dans une église de la Mission (gratuit)
									</option>
									<option>Livraison à domicile (4€/revue)</option>
								</select>
							</div>

							{this.state.showEglise && (
								<div className="form-group col-md-6">
									<label htmlFor="eglise" className="col-form-label">
										Sélectionnez votre église
									</label>
									<select
										value={this.props.app.state.elements.egliseId}
										// value={this.props.app.state.elements.eglise}
										style={{ backgroundColor: "#f6f6f6" }}
										onChange={this.handleChange}
										className="form-control"
										name="eglise"
										id="eglise"
									>
										{this.state.eglises
											.sort((a, b) => a.nom.localeCompare(b.nom))
											.map(elem => (
												<option key={elem.id} value={elem.id}>
													{elem.nom} ({elem.codePostal})
												</option>
											))}
									</select>
								</div>
							)}
						</div>
						<div className="text-right pt-2">
							<button
								type="button"
								className="btn btn-primary center-block pl-5 pr-5"
								onClick={() => this.handleSuivant()}
							>
								Suivant
							</button>
						</div>
					</form>
				</div>
			</>
		);
	}
}

export default withRouter(Livraison);
